module.exports = __webpack_public_path__ + "img/logo-header.9641d40f.png";